import React from "react"
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap"
import { Coupon } from "../Coupons"
import { useTranslation } from "react-i18next"

const CouponActionMenus = ({
  coupon,
  editCouponHandler,
  viewDetailsHandler,
  deleteCouponHandler,
  addOfferHandler,
  addCompaign,
  autoAssignToDelivery,
}: {
  coupon: Coupon
  editCouponHandler: (coupon: Coupon) => void
  viewDetailsHandler: (coupon: Coupon) => void
  deleteCouponHandler: (coupon: Coupon) => void
  addOfferHandler: (coupon: Coupon) => void
  addCompaign: (coupon: Coupon) => void
  autoAssignToDelivery: (coupon: Coupon) => void
}) => {
  const { t } = useTranslation()

  return (
    <UncontrolledDropdown>
      <DropdownToggle tag="a" className="card-drop">
        <i className="mdi mdi-dots-vertical font-size-18"></i>
      </DropdownToggle>

      <DropdownMenu className="dropdown-menu-end">
        <DropdownItem onClick={() => editCouponHandler(coupon)}>
          <span className="">{t("common_edit")}</span>
        </DropdownItem>
        <DropdownItem onClick={() => viewDetailsHandler(coupon)}>
          <span className="">{t("common_viewDetails")}</span>
        </DropdownItem>
        <DropdownItem onClick={() => addOfferHandler(coupon)}>
          <span className="">{t("common_addOffer")}</span>
        </DropdownItem>
        <DropdownItem onClick={() => addCompaign(coupon)}>
          <span className="">{t("common_addCompaign")}</span>
        </DropdownItem>
        <DropdownItem onClick={() => autoAssignToDelivery(coupon)}>
          <span className="">{t("common_autoAssignToDelivery")}</span>
        </DropdownItem>
        <DropdownItem onClick={() => deleteCouponHandler(coupon)}>
          <span className="text-danger">{t("coupons_deleteCoupon")}</span>
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  )
}

export default CouponActionMenus
